<template>
  <div class="slideBox">
    <el-carousel height="370px">
      <el-carousel-item v-for="(item, idx) in TopNewsInfos" :key="idx">
        <div class="slideItem">
          <el-image fit="cover" class="slideImg" :src="item.PicUrl">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <router-link :to="`/newsContent?id=${item.Id}`" class="slideOther">
            <h3>{{ item.Title }}</h3>
            <p>{{ item.Summary }}</p>
            <p>
              <span class="tip">{{lang=="en"?'Company News':'公司动态'}}</span>
              <span class="time">{{ moment(item.PubDate).format("YYYY-MM-DD") }}</span>
            </p>
          </router-link>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  data() {
    return {
      moment: this.$moment,
    };
  },
  props: ["TopNewsInfos","lang"],
};
</script>

<style lang="scss">
.slideBox {
  padding: 50px 0;
  .slideImg {
    transition: all 0.5s;
    width: 100%;
    &:hover {
      transform: scale(1.05);
    }
  }
  .el-carousel__indicators--horizontal {
    left: 750px;
    transform: translateX(0);
  }
    .el-carousel__button {
    background: #bfbfbf;
  }
  .is-active {
    .el-carousel__button {
      background: #d71820;
    }
  }
}
.el-carousel__item {
  background-color: #f8f8f8;
}
.slideItem {
  height: 420px;
  overflow: hidden;
  display: grid;
  grid-template-columns: 720px auto;
  justify-items: start;
}
.slideOther {
  text-align: left;

  padding: 30px;
  p {
    padding: 10px 0;
  }
}
.en .slideItem{
  p{
    line-height:1.5;
  }
}
</style>